import React, { useState } from 'react';

import SwipeableDrawer from '@core/dashboard/components/SwipeableDrawer';

import MainScreen from './MainScreen';
import Settings from './Settings';

import { IUserProfileModal, ProfileScreensEnum } from './interfaces';
import ConfirmLogoutModal, {
  useOpenConfirmLogoutModal,
} from '@components/ConfirmLogoutModal';
import { useMytaverseEvent } from '@core/dashboard/providers';
import { useChatState } from '@core/chat';

const UserProfileModal = ({ onClose, isOpen }: IUserProfileModal) => {
  const [activeScreen, setActiveScreen] = useState<ProfileScreensEnum>(
    ProfileScreensEnum.DEFAULT,
  );

  const {
    open: isOpenedConfirmLogoutModal,
    openModal: onOpenLogoutModal,
    closeModal: onCloseConfirmLogoutModal,
  } = useOpenConfirmLogoutModal();

  const { cleanStates } = useMytaverseEvent();
  const { resetState } = useChatState();

  const render = () => {
    switch (activeScreen) {
      case ProfileScreensEnum.SETTINGS:
        return <Settings onClose={onClose} setActiveScreen={setActiveScreen} />;
      case ProfileScreensEnum.DEFAULT:
        return (
          <MainScreen
            onClose={onClose}
            setActiveScreen={setActiveScreen}
            onOpenLogoutModal={onOpenLogoutModal}
          />
        );
    }
  };

  return (
    <>
      <SwipeableDrawer
        position={{
          vertical: 'top',
          horizontal: 'right',
        }}
        open={isOpen}
        onClose={onClose}
        onOpen={onClose}
      >
        {render()}
      </SwipeableDrawer>
      <ConfirmLogoutModal
        open={isOpenedConfirmLogoutModal}
        onClose={onCloseConfirmLogoutModal}
        cleanAndResetStates={[cleanStates, resetState]}
        altStyling
      />
    </>
  );
};

export default UserProfileModal;
